import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon } from 'lucide-react';
type ModalType = 'privacy' | 'terms' | null;
export function Footer() {
  const [activeModal, setActiveModal] = useState<ModalType>(null);
  return <>
      <footer className="bg-brown-dark py-10 px-6" data-id="element-65">
        <div className="max-w-4xl mx-auto flex flex-col items-center gap-4" data-id="element-66">
          <div className="flex items-center gap-6" data-id="element-67">
            <button onClick={() => setActiveModal('privacy')} className="text-cream/50 hover:text-cream text-sm transition-colors duration-200 underline underline-offset-2 decoration-cream/20 hover:decoration-cream/60" data-id="element-68">
              Política de Privacidad
            </button>
            <span className="text-cream/20" data-id="element-69">·</span>
            <button onClick={() => setActiveModal('terms')} className="text-cream/50 hover:text-cream text-sm transition-colors duration-200 underline underline-offset-2 decoration-cream/20 hover:decoration-cream/60" data-id="element-70">
              Términos y Condiciones
            </button>
          </div>
          <p className="text-cream/40 text-xs" data-id="element-71">
            © {new Date().getFullYear()} Berrinches en Calma. Todos los
            derechos reservados.
          </p>
        </div>
      </footer>

      <AnimatePresence data-id="element-72">
        {activeModal && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.2
      }} className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-brown-dark/60 backdrop-blur-sm" onClick={() => setActiveModal(null)} data-id="element-73">
            <motion.div initial={{
          opacity: 0,
          y: 20,
          scale: 0.97
        }} animate={{
          opacity: 1,
          y: 0,
          scale: 1
        }} exit={{
          opacity: 0,
          y: 10,
          scale: 0.97
        }} transition={{
          duration: 0.25,
          ease: 'easeOut'
        }} onClick={e => e.stopPropagation()} className="bg-cream rounded-2xl shadow-xl max-w-2xl w-full max-h-[80vh] overflow-hidden flex flex-col" data-id="element-74">
              {/* Header */}
              <div className="flex items-center justify-between px-8 py-5 border-b border-cream-dark" data-id="element-75">
                <h2 className="text-xl font-bold text-brown-dark font-serif" data-id="element-76">
                  {activeModal === 'privacy' ? 'Política de Privacidad' : 'Términos y Condiciones'}
                </h2>
                <button onClick={() => setActiveModal(null)} className="text-brown/40 hover:text-brown-dark transition-colors p-1 rounded-full hover:bg-cream-dark" data-id="element-77">
                  <XIcon className="w-5 h-5" data-id="element-78" />
                </button>
              </div>

              {/* Content */}
              <div className="px-8 py-6 overflow-y-auto text-brown leading-relaxed text-sm space-y-4" data-id="element-79">
                {activeModal === 'privacy' ? <PrivacyContent data-id="element-80" /> : <TermsContent data-id="element-81" />}
              </div>

              {/* Footer */}
              <div className="px-8 py-4 border-t border-cream-dark" data-id="element-82">
                <button onClick={() => setActiveModal(null)} className="w-full py-3 bg-teal-dark text-white rounded-full text-sm font-semibold hover:shadow-glow transition-shadow" data-id="element-83">
                  Entendido
                </button>
              </div>
            </motion.div>
          </motion.div>}
      </AnimatePresence>
    </>;
}
function PrivacyContent() {
  return <>
      <p data-id="element-84">
        <strong data-id="element-85">Última actualización:</strong> Marzo 2026
      </p>

      <p data-id="element-86">
        En Berrinches en Calma, respetamos tu privacidad y nos comprometemos a
        proteger la información personal que compartas con nosotros.
      </p>

      <h3 className="font-serif font-bold text-brown-dark text-base mt-6" data-id="element-87">
        1. Información que recopilamos
      </h3>
      <p data-id="element-88">
        Recopilamos únicamente la información necesaria para procesar tu compra
        y entregarte el producto digital: nombre y dirección de correo
        electrónico.
      </p>

      <h3 className="font-serif font-bold text-brown-dark text-base mt-6" data-id="element-89">
        2. Uso de la información
      </h3>
      <p data-id="element-90">Tu información se utiliza exclusivamente para:</p>
      <ul className="list-disc pl-5 space-y-1" data-id="element-91">
        <li data-id="element-92">Enviar el producto digital adquirido.</li>
        <li data-id="element-93">Comunicaciones relacionadas con tu compra.</li>
        <li data-id="element-94">Soporte al cliente en caso de ser necesario.</li>
      </ul>

      <h3 className="font-serif font-bold text-brown-dark text-base mt-6" data-id="element-95">
        3. Protección de datos
      </h3>
      <p data-id="element-96">
        No vendemos, intercambiamos ni transferimos tu información personal a
        terceros. Utilizamos medidas de seguridad estándar para proteger tus
        datos.
      </p>

      <h3 className="font-serif font-bold text-brown-dark text-base mt-6" data-id="element-97">
        4. Cookies
      </h3>
      <p data-id="element-98">
        Este sitio puede utilizar cookies para mejorar la experiencia del
        usuario. Puedes desactivarlas en la configuración de tu navegador.
      </p>

      <h3 className="font-serif font-bold text-brown-dark text-base mt-6" data-id="element-99">
        5. Tus derechos
      </h3>
      <p data-id="element-100">
        Puedes solicitar la eliminación de tus datos personales en cualquier
        momento. Responderemos a tu solicitud en un plazo máximo de 30 días.
      </p>
    </>;
}
function TermsContent() {
  return <>
      <p data-id="element-101">
        <strong data-id="element-102">Última actualización:</strong> Marzo 2026
      </p>

      <p data-id="element-103">
        Al adquirir el Kit "Berrinches en Calma", aceptas los siguientes
        términos y condiciones.
      </p>

      <h3 className="font-serif font-bold text-brown-dark text-base mt-6" data-id="element-104">
        1. Producto digital
      </h3>
      <p data-id="element-105">
        El Kit "Berrinches en Calma" es un producto digital en formato PDF que
        se entrega de forma inmediata tras la confirmación del pago. No se
        realizan envíos físicos.
      </p>

      <h3 className="font-serif font-bold text-brown-dark text-base mt-6" data-id="element-106">
        2. Uso personal
      </h3>
      <p data-id="element-107">
        El contenido adquirido es para uso personal y familiar. Queda prohibida
        su reproducción, distribución o reventa total o parcial sin autorización
        expresa.
      </p>

      <h3 className="font-serif font-bold text-brown-dark text-base mt-6" data-id="element-108">
        3. Resultados
      </h3>
      <p data-id="element-109">
        Los resultados pueden variar según cada familia y niño. El material
        ofrece herramientas basadas en evidencia, pero no constituye asesoría
        médica ni psicológica profesional.
      </p>

      <h3 className="font-serif font-bold text-brown-dark text-base mt-6" data-id="element-110">
        4. Política de reembolso
      </h3>
      <p data-id="element-111">
        Dado que se trata de un producto digital de descarga inmediata, no se
        aceptan devoluciones una vez realizada la descarga. Si tienes problemas
        técnicos con el acceso, te ayudaremos a resolverlos.
      </p>

      <h3 className="font-serif font-bold text-brown-dark text-base mt-6" data-id="element-112">
        5. Propiedad intelectual
      </h3>
      <p data-id="element-113">
        Todo el contenido del Kit "Berrinches en Calma" está protegido por
        derechos de autor. El uso no autorizado será perseguido conforme a la
        legislación vigente.
      </p>

      <h3 className="font-serif font-bold text-brown-dark text-base mt-6" data-id="element-114">
        6. Modificaciones
      </h3>
      <p data-id="element-115">
        Nos reservamos el derecho de modificar estos términos en cualquier
        momento. Las modificaciones serán efectivas desde su publicación en este
        sitio.
      </p>
    </>;
}